(() => {
  const config = window.__preaQuickAddLoaderConfig || {};
  const selector = '.quick-add, .quick-add__submit, quick-add-modal, modal-opener, product-form';

  window.__preaLazyStylesOnIntent(
    selector,
    [
      { href: config.quickAddCss, id: 'prea-quick-add-css' },
      { href: config.quickAddProductModalCss, id: 'prea-quick-add-product-modal-css' },
      { href: config.loadingOverlayCss, id: 'prea-loading-overlay-css' }
    ]
  );

  if (!config.isIndex) return;

  let loaded = false;
  let loadQueued = false;

  const loadQuickAdd = () => {
    if (loaded) return;
    loaded = true;
    loadQueued = false;

    window
      .__preaLoadScript(config.productFormJs, 'prea-product-form-js')
      .then(() => window.__preaLoadScript(config.quickAddJs, 'prea-quick-add-js'))
      .catch(() => {
        loaded = false;
      });
  };

  const scheduleQuickAddLoad = () => {
    if (loaded || loadQueued) return;
    loadQueued = true;

    const run = () => {
      if (!loaded) loadQuickAdd();
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 1400 });
    } else {
      window.setTimeout(run, 650);
    }
  };

  const observeQuickAdd = () => {
    const targets = document.querySelectorAll(selector);
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      window.setTimeout(scheduleQuickAddLoad, 1800);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      scheduleQuickAddLoad();
    }, { rootMargin: '0px 0px 80px 0px' });

    targets.forEach((target) => observer.observe(target));
  };

  const onQuickAddIntent = (event) => {
    if (!event.target || !event.target.closest || !event.target.closest(selector)) return;
    loadQuickAdd();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeQuickAdd, { once: true });
  } else {
    observeQuickAdd();
  }

  document.addEventListener('pointerover', onQuickAddIntent, { capture: true, passive: true });
  document.addEventListener('pointerdown', onQuickAddIntent, { capture: true, passive: true });
  document.addEventListener('focusin', onQuickAddIntent, { capture: true });
})();

